import React, { useState, useEffect } from 'react';
import { createUserWithEmailAndPassword, sendEmailVerification, getAuth } from 'firebase/auth';
import { getFirestore, doc, setDoc } from 'firebase/firestore';
import appFirebase from '../Firebase/Firebase';
import './RegisterForm.css';
import logoClaro from '../images/Logo.png';
import logoDark from '../img/logoDark.png';
import { FaRegEye } from "react-icons/fa";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const db = getFirestore(appFirebase);
const auth = getAuth(appFirebase);

const RegisterForm = ({ handleTabChange }) => {
  const [registerForm, setRegisterForm] = useState({
    name: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
    phone: ''
  });

  const [logo, setLogo] = useState(logoDark);
  useEffect(() => {
    if (localStorage.getItem('darkMode') === 'true') {
      setLogo(logoDark);
    } else {
      setLogo(logoClaro);
    }
  }, []);
  const [errors, setErrors] = useState({});
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const handleRegisterChange = (e) => {
    const { id, value } = e.target;
    setRegisterForm((prevForm) => ({ ...prevForm, [id]: value }));
  };

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const handleRegisterSubmit = async (e) => {
    e.preventDefault();
    const formErrors = {};

    if (!registerForm.name) formErrors.name = 'Nombre es requerido';
    if (!registerForm.lastName) formErrors.lastName = 'Apellido es requerido';
    if (!registerForm.email) formErrors.email = 'Correo es requerido';
    if (!registerForm.phone) {
      formErrors.phone = 'Teléfono es requerido';
    } else if (!/^\+?\d{9,15}$/.test(registerForm.phone)) {
      formErrors.phone = 'Número de teléfono no válido';
    }

    if (!registerForm.password) formErrors.password = 'Contraseña es requerida';
    if (registerForm.password !== registerForm.confirmPassword) {
      formErrors.confirmPassword = 'Las contraseñas no coinciden';
    }

    setErrors(formErrors);
    if (Object.keys(formErrors).length > 0) return;

    try {
      const credentials = await createUserWithEmailAndPassword(auth, registerForm.email, registerForm.password);
      await sendEmailVerification(credentials.user);
      const validityTime = 30; // Días de vigencia
      const fechaExpiracion = new Date();
      fechaExpiracion.setDate(fechaExpiracion.getDate() + validityTime);
      const userData = {
        userId: credentials.user.uid,
        email: credentials.user.email,
        name: registerForm.name,
        lastName: registerForm.lastName,
        phone: registerForm.phone,
        role: 'user',
        coins: 200,
        coinsComprados: 200,
        coinRenovation: new Date(),
        coinExpiration: fechaExpiracion,

        // Si desea ser anfitrión, deberás solicitar estos campos más adelante:
        // companyName, ruc, phone_em, city, sector, parish, mainStreet, secondaryStreet, number_em, postalCode, reference
      };

      await setDoc(doc(db, 'usuarios', credentials.user.uid), userData);
          toast.success(`🎉 ¡Bienvenido a La OFI.WORK! Por tu registro has ganado ${userData.coins} coins.`);

      handleTabChange('verifyEmail');
    } catch (error) {
      console.error('Error al registrar el usuario:', error.message);
      toast.error("Error al registrar el usuario");
    }
  };

  return (
    <div className="register-container">
      <ToastContainer />
      <img src={logo} alt="Logo" className="register-logo" />
      <form className="register-form" onSubmit={handleRegisterSubmit}>
        <div className="register-field">
          <input id="name" type="text" placeholder=" " value={registerForm.name} onChange={handleRegisterChange} required />
          <label htmlFor="name">Nombre</label>
          {errors.name && <p className="register-error">{errors.name}</p>}
        </div>
        <div className="register-field">
          <input id="lastName" type="text" placeholder=" " value={registerForm.lastName} onChange={handleRegisterChange} required />
          <label htmlFor="lastName">Apellido</label>
          {errors.lastName && <p className="register-error">{errors.lastName}</p>}
        </div>
        <div className="register-field">
          <input id="email" type="email" placeholder=" " value={registerForm.email} onChange={handleRegisterChange} required />
          <label htmlFor="email">Correo electrónico</label>
          {errors.email && <p className="register-error">{errors.email}</p>}
        </div>
        <div className="register-field">
          <label className="register-label">Teléfono</label>
          <PhoneInput
            country={'ec'}
            value={registerForm.phone}
            onChange={(phone) =>
              setRegisterForm((prev) => ({ ...prev, phone }))
            }
            inputProps={{
              name: 'phone',
              required: true,
              autoFocus: false
            }}
            inputStyle={{
              width: '100%',
              padding: '12px',
              borderRadius: '6px',
              border: '1px solid #ff820f'
            }}
          />
          {errors.phone && <p className="register-error">{errors.phone}</p>}
        </div>

        <div className="register-field register-password">
          <input id="password" type={isPasswordVisible ? "text" : "password"} placeholder=" " value={registerForm.password} onChange={handleRegisterChange} required />
          <label htmlFor="password">Contraseña</label>
          <FaRegEye className="register-toggle-icon" onClick={togglePasswordVisibility} />
          {errors.password && <p className="register-error">{errors.password}</p>}
        </div>
        <div className="register-field">
          <input id="confirmPassword" type={isPasswordVisible ? "text" : "password"} placeholder=" " value={registerForm.confirmPassword} onChange={handleRegisterChange} required />
          <label htmlFor="confirmPassword">Confirmar contraseña</label>
          {errors.confirmPassword && <p className="register-error">{errors.confirmPassword}</p>}
        </div>
        <div className="register-submit-section">
          <button type="submit" className="register-btn-submit">Registrarse</button>
        </div>
      </form>
      <div className="register-footer">
        ¿Ya tienes una cuenta?
        <span className="register-link" onClick={() => handleTabChange('login')}> Inicia sesión aquí.</span>
      </div>
    </div>
  );
};

export default RegisterForm;
